// Estado + timers do flyout de subitens, compartilhado entre as sidebars de
// contexto (gestão/cliente). Os delays evitam o flicker do hover: o painel só
// abre se o mouse permanecer no item, e só fecha se o mouse sair do item E do
// painel (o `cancelClose` mantém aberto no corredor item→painel).

// Delay para abrir (mouse precisa permanecer) e para fechar (tolerância no
// corredor item→painel). Em ms.
export const OPEN_DELAY_MS = 120
export const CLOSE_DELAY_MS = 180

export default {
  data() {
    return {
      // { item, top, left } do módulo cujo flyout está aberto; null = fechado.
      flyout: null,
      flyoutOpenTimer: null,
      flyoutCloseTimer: null,
    }
  },
  beforeDestroy() {
    this.clearFlyoutTimers()
  },
  methods: {
    clearOpenTimer() {
      if (this.flyoutOpenTimer) clearTimeout(this.flyoutOpenTimer)
      this.flyoutOpenTimer = null
    },
    clearCloseTimer() {
      if (this.flyoutCloseTimer) clearTimeout(this.flyoutCloseTimer)
      this.flyoutCloseTimer = null
    },
    clearFlyoutTimers() {
      this.clearOpenTimer()
      this.clearCloseTimer()
    },
    // Agenda abrir o flyout do `payload` ({ item, top, left }). Cancela qualquer
    // fechamento pendente (troca de módulo sem piscar).
    openFlyout(payload) {
      this.cancelClose()
      this.clearOpenTimer()
      this.flyoutOpenTimer = setTimeout(() => {
        this.flyout = payload
        this.flyoutOpenTimer = null
      }, OPEN_DELAY_MS)
    },
    // Agenda fechar; também cancela uma abertura ainda pendente (mouse passou rápido).
    scheduleClose() {
      this.clearOpenTimer()
      this.clearCloseTimer()
      this.flyoutCloseTimer = setTimeout(() => {
        this.flyout = null
        this.flyoutCloseTimer = null
      }, CLOSE_DELAY_MS)
    },
    cancelClose() {
      this.clearCloseTimer()
    },
    closeFlyoutNow() {
      this.clearFlyoutTimers()
      this.flyout = null
    },
  },
}
